import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../global/Navbar';
import Footer from '../global/Footer';
import { NotFoundMeta } from '../shared/PageMeta';
import { applyNotFoundShellHead } from '../../../content/seoMeta';

export default function NotFound() {
  const { pathname } = useLocation();

  useEffect(() => applyNotFoundShellHead(pathname), [pathname]);

  return (
    <div>
      <NotFoundMeta pathname={pathname} />
      <Navbar />
      <main className="container-x py-24 sm:py-32">
        <p className="eyebrow">404</p>
        <h1 className="mt-3 text-4xl font-semibold tracking-tight text-ink-900 sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-4 max-w-xl text-lg leading-relaxed text-ink-600">
          That address is not a page on the MyOrgLab website.
        </p>
        <a href="/" className="btn-primary mt-8 inline-flex">
          Back to home
        </a>
      </main>
      <Footer />
    </div>
  );
}
